var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.414 9.70703C1.41336 9.70703 1.41275 9.70678 1.41229 9.70632L0.706607 9.00014C0.316319 8.60957 0.31643 7.9766 0.706857 7.58617L3.99978 4.29326C4.39035 3.90269 5.0236 3.90274 5.41411 4.29337L7.707 6.58703L11.293 3.00003H9.707C9.15472 3.00003 8.707 2.55232 8.707 2.00003C8.707 1.44775 9.15472 1.00003 9.707 1.00003H14.707V6.00103C14.707 6.55332 14.2593 7.00103 13.707 7.00103C13.1547 7.00103 12.707 6.55332 12.707 6.00103V4.41503L8.41399 8.70718C8.0235 9.0976 7.39048 9.09762 6.99996 8.70723L4.707 6.41503L1.41571 9.70632C1.41525 9.70678 1.41464 9.70703 1.414 9.70703Z",
    fill: "#FFDD7B",
    stroke: "#373946",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankUpIcon);
export default __webpack_public_path__ + "static/media/rank-up-icon.e29350dfc812138d81d4326047a1758f.svg";
export { ForwardRef as ReactComponent };